import { clearSession, finishSession, processQueue } from '../../services/manager';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../../components/Button';
import VideoPlayer from '../../components/VideoPlayer'
import SessionScreen from './SessionScreen';

export default function Screen(props: WrapperScreenProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    props.useAudio('');
    (async function() {
      await processQueue();
      await finishSession();
    })();
  });

  async function answer() {
    await clearSession();
    navigate('/', { replace: true });
  }

  const actions = (<>
    <Button label={t('exit')} variant="primary" onClick={() => answer()} />
  </>);

  return (
    <SessionScreen
      screen="77"
      title={`${t('screens:77.step')} ${t('screens:77.title')}`}
      chapter={6}
      progress={100}
      audio={t('screens:77.audio')}
      actions={actions}
    >
      {/* <Markdown value={t('screens:77.text')} /> */}
      <VideoPlayer src={t('screens:77.source')} poster={t('screens:77.poster')} />
    </SessionScreen>
  );
};
